import { render, staticRenderFns } from "./ActiveAccreditedCpds.vue?vue&type=template&id=f4f0c8c4&scoped=true"
import script from "./ActiveAccreditedCpds.vue?vue&type=script&lang=js"
export * from "./ActiveAccreditedCpds.vue?vue&type=script&lang=js"
import style0 from "./ActiveAccreditedCpds.vue?vue&type=style&index=0&id=f4f0c8c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4f0c8c4",
  null
  
)

export default component.exports